import Chip from '@mui/material/Chip';
import { palette } from '@openx/components-core/lib/theme/paletteV2';

const createColorStyle = (bgColor: string, textColor: string) => ({
  backgroundColor: bgColor,
  color: textColor,
  '&:hover': {
    backgroundColor: bgColor,
  },
});

const stylesByType = {
  High: createColorStyle(palette.info.light, palette.info.dark),
  Balanced: createColorStyle(palette.success.light, palette.success.dark),
  Scaled: createColorStyle(palette.warning.light, palette.warning.dark),
  Seed: createColorStyle(palette.primary.light, palette.primary.dark),
};

export const ReachType = ({ type }: { type: string }) => {
  const label = type === 'Seed' ? 'Seed Base' : type;

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        paddingInline: 1.5,
        paddingBlock: 0.5,
        margin: 0,
        ...stylesByType[type],
      }}
    />
  );
};
